import { FileNameCell } from '@/features/export_files/List/Table/Columns/Cells/FileNameCell';
import { FileStatusCell } from '@/features/export_files/List/Table/Columns/Cells/FileStatusCell';
import { ExportFileColumn } from '@/features/export_files/List/type';
import { useTranslation } from '@/i18n';
import { formatFileSize } from '@/utils/convert/formatFileSize';
import { ColumnType } from 'antd/es/table/interface';
import { formatDateWithTime } from 'date-util';

type ActionHandlers = {
  onDownloadClick: (fileId: string, fileName: string) => Promise<void>;
  onDeleteClick: (fileId: string) => Promise<void>;
};

export const useExportFilesColumns = (
  actionHandlers?: ActionHandlers
): ColumnType<ExportFileColumn>[] => {
  const { t } = useTranslation();

  return [
    {
      title: t('export_files_type'),
      dataIndex: 'content_type',
      key: 'content_type',
      width: 180,
      render: () => {
        return t('export_files_type_document_notice');
      },
    },
    {
      title: t('export_files_status'),
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (_: unknown, row: ExportFileColumn) => {
        return <FileStatusCell status={row.status} />;
      },
    },
    {
      title: t('export_files_executed_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 160,
      render(value: string) {
        return formatDateWithTime(value);
      },
    },
    {
      title: t('export_files_finished_at'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 160,
      render(value: string, row: ExportFileColumn) {
        if (row.status === 'processing' || row.status === 'failed') return null;
        return formatDateWithTime(value);
      },
    },
    {
      title: t('export_files_file_name'),
      dataIndex: 'name',
      key: 'name',
      width: 400,
      render: (_: unknown, row: ExportFileColumn) => {
        return <FileNameCell row={row} actionHandlers={actionHandlers} />;
      },
    },
    {
      title: t('export_files_file_size'),
      dataIndex: 'byte_size',
      key: 'byte_size',
      width: 110,
      render: (_: unknown, row: ExportFileColumn) => {
        if (!row.byte_size) return null;
        return <span>{formatFileSize(row.byte_size)}</span>;
      },
    },
    {
      title: t('export_files_executor'),
      dataIndex: 'office_member',
      key: 'office_member',
      width: 120,
      render: (_: unknown, row: ExportFileColumn) => (
        <span>{row.office_member.name}</span>
      ),
    },
  ];
};
